import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store'
import { GoogleOAuthProvider } from '@react-oauth/google';
import { setupInterceptor } from './apiInterceptor';

setupInterceptor(store);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_AUTH_KEY}>
      <App />
    </GoogleOAuthProvider>
  </Provider>
);
reportWebVitals();

